module.exports = __webpack_public_path__ + "img/cl_five_steps.709baf86.png";